/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
// eslint-disable-next-line no-unused-vars
import {
    IdeaCreateAdmin,
    IdeaCreateAdminFromJSON,
    IdeaCreateAdminToJSON,
    IdeaDraftAdminAllOf,
    IdeaDraftAdminAllOfFromJSON,
    IdeaDraftAdminAllOfToJSON,
    IdeaVisibility,
    IdeaVisibilityFromJSON,
    IdeaVisibilityToJSON,
    NotifySubscribers,
    NotifySubscribersFromJSON,
    NotifySubscribersToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdeaDraftAdmin
 */
export interface IdeaDraftAdmin {
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    authorUserId: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    categoryId: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaDraftAdmin
     */
    tagIds: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    response?: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    statusId?: string;
    /**
     * 
     * @type {number}
     * @memberof IdeaDraftAdmin
     */
    fundGoal?: number;
    /**
     * 
     * @type {NotifySubscribers}
     * @memberof IdeaDraftAdmin
     */
    notifySubscribers?: NotifySubscribers;
    /**
     * 
     * @type {Array<string>}
     * @memberof IdeaDraftAdmin
     */
    linkedFromPostIds?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof IdeaDraftAdmin
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    coverImg?: string;
    /**
     * 
     * @type {IdeaVisibility}
     * @memberof IdeaDraftAdmin
     */
    visibility?: IdeaVisibility;
    /**
     * Private notes visible only to admins and moderators
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    adminNotes?: string;
    /**
     * 
     * @type {string}
     * @memberof IdeaDraftAdmin
     */
    draftId: string;
    /**
     * 
     * @type {Date}
     * @memberof IdeaDraftAdmin
     */
    lastSaved: Date;
}

export function IdeaDraftAdminFromJSON(json: any): IdeaDraftAdmin {
    return {
        'authorUserId': json['authorUserId'],
        'title': json['title'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'categoryId': json['categoryId'],
        'tagIds': json['tagIds'],
        'response': !exists(json, 'response') ? undefined : json['response'],
        'statusId': !exists(json, 'statusId') ? undefined : json['statusId'],
        'fundGoal': !exists(json, 'fundGoal') ? undefined : json['fundGoal'],
        
        'notifySubscribers': !exists(json, 'notifySubscribers') ? undefined : NotifySubscribersFromJSON(json['notifySubscribers']),
        'linkedFromPostIds': !exists(json, 'linkedFromPostIds') ? undefined : json['linkedFromPostIds'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'coverImg': !exists(json, 'coverImg') ? undefined : json['coverImg'],
        
        'visibility': !exists(json, 'visibility') ? undefined : IdeaVisibilityFromJSON(json['visibility']),
        'adminNotes': !exists(json, 'adminNotes') ? undefined : json['adminNotes'],
        'draftId': json['draftId'],
        'lastSaved': new Date(json['lastSaved']),
    };
}

export function IdeaDraftAdminToJSON(value?: IdeaDraftAdmin): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'authorUserId': value.authorUserId,
        'title': value.title,
        'description': value.description,
        'categoryId': value.categoryId,
        'tagIds': value.tagIds,
        'response': value.response,
        'statusId': value.statusId,
        'fundGoal': value.fundGoal,
        
        'notifySubscribers': NotifySubscribersToJSON(value.notifySubscribers),
        'linkedFromPostIds': value.linkedFromPostIds,
        'order': value.order,
        'coverImg': value.coverImg,
        
        'visibility': IdeaVisibilityToJSON(value.visibility),
        'adminNotes': value.adminNotes,
        'draftId': value.draftId,
        'lastSaved': value.lastSaved.toISOString(),
    };
}


